<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-content">
    <div class="fields">
      <mat-form-field>
        <mat-label>{{ 'DESCRIPTION' | translate }}</mat-label>
        <textarea matInput formControlName="description" [maxlength]="MAX_INPUT_LENGTH"></textarea>
        <mat-error>{{'FIELD_ERROR.DESCRIPTION' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field >
        <mat-label>{{ 'CATEGORY' | translate}}</mat-label>
        <mat-select formControlName="category">
          <mat-option *ngFor="let item of FAILURE_CATEGORY | keyvalue: originalOrder" [value]="item.value">
            <status-point [background]="item.value"></status-point>
            {{ item.value | translate}}
          </mat-option>
        </mat-select>
        <mat-error>{{'FIELD_ERROR.CATEGORY' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field >
        <mat-label>{{ 'FAILURE_CODE' | translate}}</mat-label>
        <mat-select formControlName="failureCodes" [multiple]="data.failureMultiselect" [compareWith]="compareFailureCodes">
          <mat-select-trigger>{{ getCodeLabel() }}</mat-select-trigger>
          <mat-option *ngFor="let item of data.failureCodeList" [value]="item">{{ item.code }}</mat-option>
          <mat-option *ngIf="data.failureCodeList.length === 0" [value]="noCodeOption">Nie dotyczy</mat-option>
        </mat-select>
        <mat-error>{{'FIELD_ERROR.FAILURE_CODE' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'COMMENT' | translate }}</mat-label>
        <textarea matInput formControlName="comment"></textarea>
      </mat-form-field>
    </div>
    <files-list
      formControlName="photos"
      type="PHOTO"
      (uploadEvent)="uploadFile($event)"
      (deleteFileEvent)="deleteFile($event)"
      [disableUpload]="false"
      [disableDelete]="false"
    ></files-list>
    <div *ngIf="!data.disabled" class="buttons-wrapper">
      <button *ngIf="data.failureDescription" mat-flat-button type="button" color="primary" (click)="delete()">{{ 'DEFECTS.DELETE' | translate }}</button>
      <div class="flex-grow"></div>
      <button mat-flat-button type="button" mat-dialog-close>{{ 'CANCEL' | translate }}</button>
      <button mat-flat-button color="primary" type="submit">{{ 'SAVE' | translate }}</button>
    </div>
  </div>
</form>
